export function popupOpener() {
    let $body = $("body");
    let popupOpener = $(".popup-opener");
    let popupClose = $(".close-popup");
    let $popup = $(".popup");
    let $videoHolder = $popup.find(".video-holder");


    $(document).on("click", ".popup-opener", function (e) {
        e.preventDefault();
        let $this = $(this);
        let target = $this.attr("href");
        let data = {
            'action': 'get_full_info',
            'person_id': $this.attr('data-person')
        };

        if (target === "#video-popup") {
            let src = $this.data("video-src") + '?enablejsapi=1&autoplay=0';
            let video = '<iframe src="' + src + '" frameborder="0" allow="autoplay" allowfullscreen playsinline></iframe>';
            $(target).find('.video-holder').append(video);
            $videoHolder.fadeIn(400);

            if ($this.hasClass('play-video') && !$this.hasClass('video-activated')) {
                setTimeout(function () {
                    $(target).find('iframe')[0].contentWindow.postMessage('{"event":"command", "method":"play", "func":"' + 'playVideo' + '","args":""}', '*');
                }, 1000);
            }
            $(target).addClass("show");
            $body.addClass("overflow");
        }
        if (target === "#popup-bio") {
            $.ajax({
                url: ajaxvars.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function beforeSend() {
                },
                success: function success(response) {
                    if (response) {
                        $('#popup-bio .bio-popup-holder').html(response);
                    }
                    $(target).addClass("show");
                    $body.addClass("overflow");
                },
                complete: function complete() {
                }
            });
        }
        if (target === "#popup-form") {
            $(target).addClass("show");
            $body.addClass("overflow");
        }
        if (target === "#popup-gallery") {
            if (window.innerWidth >= 768) {
                let index = $this.parents(".item").index();
                let gallery = $this.parents(".mosaic-gallery .holder")
                let galleryHolderBig = $(".popup-gallery-big");
                let galleryHolderSmall = $(".popup-gallery-small");
                gallery.clone().appendTo(galleryHolderBig);
                gallery.clone().appendTo(galleryHolderSmall);
                let galleryBig = galleryHolderBig.find(".holder")
                let gallerySmall = galleryHolderSmall.find(".holder")

                galleryBig.slick({
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: true,
                    asNavFor: gallerySmall,
                    prevArrow: '<button class="slick-prev"><svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<path d="M6.70213 10V5.50562H18V4.49438H6.70213V0L0 4.98876L6.70213 10Z" fill="#fff"/>\n' +
                        '</svg></button>',
                    nextArrow: '<button class="slick-next"><svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<path d="M11.2979 10V5.50562H0V4.49438H11.2979V0L18 4.98876L11.2979 10Z" fill="#fff"/>\n' +
                        '</svg></button>',

                });
                gallerySmall.slick({
                    // slidesToShow: 4,
                    infinite: false,
                    slidesToScroll: 1,
                    variableWidth: true,
                    asNavFor: galleryBig,
                    centerMode: true,
                    focusOnSelect: true,
                    arrows: false
                });

                galleryBig.slick('slickGoTo', index);
                gallerySmall.slick('slickGoTo', index);

                $(target).addClass("show");
                $body.addClass("overflow");
            }
        }

    });

    function closePopup() {
        if ($popup.find('iframe').length) {
            $videoHolder.fadeOut(300);
            $popup.find('iframe').remove();
        }
        if ($popup.find('.popup-gallery-holder').length) {
            setTimeout(function () {
                $popup.find(".holder").remove();
            }, 500);
        }
        $popup.removeClass("show").find('.bio-popup-info').remove();
        $body.removeClass("overflow");

    }

    popupClose.on("click", function (e) {
        closePopup();
    });

    $popup.on("click", function (event) {
        if (!$(event.target).closest(".popup-holder").length && !$(event.target).closest(".jcf-select-drop").length) {
            closePopup.call(this);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/popupOpener.js